import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Guitar } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="relative bg-gray-100 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-10">
        <div className="absolute top-0 left-0 right-0 h-40 bg-gradient-to-b from-gray-200 to-transparent"></div>
        <div className="grid grid-cols-10 h-full">
          {Array.from({ length: 200 }).map((_, i) => (
            <div 
              key={i} 
              className="border-[0.5px] border-gray-300"
              style={{ animationDelay: `${Math.random() * 5}s` }}
            ></div>
          ))}
        </div>
      </div>
      
      {/* Hero Content */}
      <div className="container-custom relative z-10 py-16 md:py-24 lg:py-32">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-flex items-center rounded-full bg-red-100 px-3 py-1 text-sm font-medium text-red-700 mb-4">
              <Guitar className="mr-1 h-4 w-4" /> Premium Music Shop
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-black mb-4">
              Find Your <span className="text-red-700">Perfect</span> Sound
            </h1>
            <p className="text-lg text-gray-700 mb-8 max-w-lg">
              Discover premium instruments and accessories for musicians of all levels. From guitars and keyboards to drums and DJ equipment.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Link 
                to="/products" 
                className="btn btn-primary px-6 py-3"
              >
                Shop Now
              </Link>
              <Link 
                to="/about" 
                className="btn btn-outline border-gray-800 text-gray-800 hover:bg-gray-800 hover:text-white px-6 py-3"
              >
                Learn More
              </Link>
            </div>
          </motion.div>
          
          <motion.div 
            className="relative hidden md:block"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <img 
              src="https://images.pexels.com/photos/164743/pexels-photo-164743.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" 
              alt="Piano keyboard" 
              className="rounded-lg shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500"
            />
            <div className="absolute -bottom-6 -right-6">
              <img 
                src="https://images.pexels.com/photos/164693/pexels-photo-164693.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" 
                alt="Microphone" 
                className="w-40 h-40 object-cover rounded-lg shadow-xl transform -rotate-6 hover:rotate-0 transition-transform duration-500 border-4 border-white"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;